// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"faf5c65f","885":"66fd6197"}[chunkId] + ".chunk.js";
};